export const cartLine = `
id
quantity
attributes {
  key
  value
}
cost {
  compareAtAmountPerQuantity {
    amount
    currencyCode
  }
  totalAmount {
    amount
    currencyCode
  }
}
discountAllocations {
  discountedAmount {
    amount
    currencyCode
  }
}
merchandise {
  ... on ProductVariant {
    id
    quantityAvailable
    sku
    shippingStatus: metafield(namespace: "details", key: "shipping_status"){
      value
    }
    retailPrice: metafield(
      namespace: "custom", key: "retail_price"
    ){
      value
    }
    negativeInventoryShippingStatus: metafield(
      namespace: "details", key: "negative_inventory_shipping_status"
    ){
      value
    }
    displayNegativeInventoryForDTC: metafield(
      namespace: "custom", key: "display_negative_inventory_status_to_dtc"
    ){
      value
    }
    selectedOptions {
      name
      value
    }
    image {
      width
      height
      url
      altText
    }
    product {
      ... on Product {
        title
        handle
        shippingStatus: metafield(namespace: "value_prop", 
        key: "shipping_status"){
         value
        }
				retailPrice: metafield(
					namespace: "custom", key: "retail_price"
				){
					value
				}
        sellInSets: metafield(
        namespace: "details", key: "sell_in_sets"
        ){
          value
        }
      }
    }
  }
}
`;

export const cart = `
checkoutUrl
id
totalQuantity
cost {
  subtotalAmount {
    amount
    currencyCode
  }
  totalAmount {
    amount
    currencyCode
  }
}
lines(first: 50) {
  edges {
    node {
      ${cartLine}
    }
  }
}
`;

export const variant = `
availableForSale
id
price {
  amount
  currencyCode
}
compareAtPrice {
  amount
  currencyCode
}
selectedOptions {
  name
  value
}
shippingStatus: metafield(namespace: "details", key: "shipping_status") {
  value
}
retailPrice: metafield(
	namespace: "custom", key: "retail_price"
){
	value
}
negativeInventoryShippingStatus: metafield(
  namespace: "details", key: "negative_inventory_shipping_status"
){
  value
}
displayNegativeInventoryForDTC: metafield(
  namespace: "custom", key: "display_negative_inventory_status_to_dtc"
){
  value
}
quantityAvailable
continueSellingOnlyForB2b: metafield(
  namespace: "custom", 
  key: "continue_selling_when_out_of_stock_only_for_b2b_customers"
){
  value
}
`;

export const product = `
availableForSale
handle
id
title
handle
images(first: 50) {
  edges {
    node {
      alt: altText
      height
      id
      src: url(transform: { preferredContentType: WEBP })
      width
    }
  }
}
options {
  id
  name
  values
}
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
retailPrice: metafield(
		namespace: "custom", key: "retail_price"
){
	value
}
sellInSets: metafield(
  namespace: "details", key: "sell_in_sets"
){
  value
}
compareAtPriceRange {
  minVariantPrice {
    amount
    currencyCode
  }
}
variants(first: 100) {
  edges {
    node {
      ${variant}
    }
  }
}
shippingStatus: metafield(namespace: "value_prop", 
  key: "shipping_status"){value}
`;
